
import { defineComponent } from "vue";
import PlanCardContent from "./PlanCardContent.vue";
import CustomPlanCardContent from "./CustomPlanCardContent.vue";
import { STATE_MODULES } from "@/store/state-modules";
import { LeadsPlanMixin } from "@/utils/mixins";
import { LeadsMutations } from "@/store/modules/leads/mutations";

const __default__ = defineComponent({
	mixins: [LeadsPlanMixin],
	data () {
		return {
			errorMessage: ''
		}
	},
	components: { PlanCardContent, CustomPlanCardContent },
	props: {
		bgImage: { 
			type: String,
			required: true
		}
	},
	computed: {
		planContentComp (): string {
			return this.isCustomPlan ? 'CustomPlanCardContent' : 'PlanCardContent';
		}
	},
	methods: {
		onPlanClick (): void { 
			this.errorMessage = '';
			this.$store.commit(`${STATE_MODULES.LEADS}/${LeadsMutations.TOGGLE_SELECTED_PLAN}`, this.plan.id)
		}
	}
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "a5e8d3aa": (`url('${_ctx.bgImage}')`)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__